/* unplugin-vue-components disabled */import { render } from "./companyProfile.vue?vue&type=template&id=c2d77898&scoped=true"
import script from "./companyProfile.vue?vue&type=script&lang=js"
export * from "./companyProfile.vue?vue&type=script&lang=js"

import "../../assets/css/init/column.less?vue&type=style&index=0&id=c2d77898&lang=less&scoped=true"
import "../../assets/css/about/about.less?vue&type=style&index=1&id=c2d77898&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d77898"]])

export default __exports__